import { testIf } from '../validationFunctions';
import { mergeArrays } from '../../mergeFunctions';
import { successState, formatResults } from '../validationHelpers';

export const validateLogin = ({ data, setNotificationText }) => {
  const emptyRes = testIf('empty')(data, ['email', 'password']);
  const emailRes = testIf('email')(data, ['email']);
  const testResults = mergeArrays([emptyRes, emailRes]);
  if (testResults.length === 0) return successState(setNotificationText);
  setNotificationText(formatResults(testResults));
};
